module.exports = __webpack_public_path__ + "img/gesture_ok.774d1741.png";